
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom"
import { Box, Button, Grid, TextField } from "@mui/material";
import { LayoutCrearDoc } from "../../layouts";
import { TablaModeloItems } from "../../ui";
import { useCarritoXID } from "../../../hooks/cache";
import { CargandoMedio, MensajeAlertaDanger } from "../../components";
import { editarValoresDetalles } from "../../../services";
import { useQueryClient } from "@tanstack/react-query";

const baseUrl = process.env.REACT_APP_API_URL;




export const DetalleItemCompra = () => {


    const { id } = useParams();
    const queryClient = useQueryClient();
    const { data, isLoading } = useCarritoXID(id);
    const [detalles, setDetalles] = useState('');



    useEffect(() => {
        if( data ){ setDetalles(data?.detalles || '') }
    }, [data])
    


    const handleDetalles = async(e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            const detallesTrimmed = detalles.trim();
            if (!detallesTrimmed) return;
            await editarValoresDetalles({ id, detalles: detallesTrimmed });
            queryClient.invalidateQueries({ queryKey: ['itemxid'] });
        }
    };


    const handlePictureClick = () => {
        document.querySelector('#fileSelector').click();
    }

    const handleFileChange = async(e) => {
        const file = e.target.files[0];
        if( file ) {
            await editarValoresDetalles({ id, img: file });
            queryClient.invalidateQueries({ queryKey: ['itemxid'] });
        }
    }


    return (

        <LayoutCrearDoc titulo='Detalles del Producto' add={false} subtitulo="Agregar detalles al items">
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de item..." />
            :   (data)
                ?   <>
                    <TablaModeloItems activeCarrito={ data } />
                    <Grid container sx={{display:'flex', justifyContent:'space-between', my:2}}>
                        <Grid item xs={12} sm={6}>
                            <Grid container>
                                <TextField
                                    type="text"
                                    fullWidth
                                    multiline
                                    rows={11}
                                    placeholder="Describe tu solicitud y presiona Enter para guardarla..."
                                    value={detalles}
                                    onChange={({ target }) => setDetalles(target.value)}
                                    onKeyDown={ handleDetalles }
                                />
                            </Grid>
                        </Grid>

                        <Grid item xs={12} sm={5} >
                            <input type="file" id="fileSelector" className="boton-file" onChange={ handleFileChange } />

                            <Box sx={{width:'100%', height:260 }}>
                                <img src={`${ baseUrl }/uploads/items/${ data?.imgCliente }`} 
                                alt="Imagen Detalle" style={{width:'100%', height:'100%'}} />
                            </Box>

                            <Grid container>
                                <Button variant="contained" color="secondary" fullWidth onClick={ handlePictureClick } > 
                                    Subir Archivo
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                    </>

                :   <MensajeAlertaDanger titulo='No hay información del item...' />
            }
        </LayoutCrearDoc>

    )
}
